import React from "react";
import { Card, CardBody, CardSubtitle } from "reactstrap";

const VisitsComponent = ({ data, onClick }) => {
    // Determine the border color class based on status
  const getStatusClass = (status) => {
    switch (status) {
      case 'In Progress':
        return 'border-yellow';
      case 'Done':
        return 'border-green';
      default:
        return 'border-black';
    }
  };

  return (
    <div
      onClick={() => onClick(data)}
      className="col-lg-3 col-md-3 col-6 mt-4"
      style={{ marginBottom: "1.5rem", cursor: "pointer" }}
      key={data.id}
    >
      <Card className={`carer-visits ${getStatusClass(data.status)}`}>
        <CardBody style={{ textAlign: "center", paddingBottom: "0px" }}>
          <div className="car-body-wrapper cards-body">
            <CardSubtitle
              style={{
                padding: "16px 0px 10px 0px",
                color: "black",
                fontWeight: 800,
                fontSize: "1rem",
              }}
            >
              {data.service_user} - {data.event_name}
            </CardSubtitle>
            <div style={{ color: "#666", fontSize: "0.9rem" }}>
              <span> {data.visit_start_time} - {data.visit_end_time}</span>
            </div>
            <div style={{ color: "#3f51b5", fontSize: "0.7rem", fontWeight: "bold" }}>
              <span> {data.visit_date}</span>
            </div>
            {/*<div style={{ color: "#888", fontSize: "0.8rem", marginTop: "5px" }}>*/}
            {/*  Instructions: {data.instructions || "No instructions provided"}*/}
            {/*</div>*/}
          </div>
        </CardBody>
        <div
          style={{
            textAlign: "center",
            color: "#424242",
            fontSize: "12px",
            fontWeight: 700,
            padding: "1rem",
          }}
        >
          <span>
            {data.status.capitalize()}
          </span>
        </div>
      </Card>
    </div>
  );
};

export default VisitsComponent;
